export const menus = [
    {
        title: "About",
        children: [
            { title: "Biography" },
            { title: "CV" },
        ],
    },
    {
        title: "Research",
        children: [
            { title: "Interaction Lab"},
            { title: "Students"},
            // { title: "Areas" },
            // { title: "Domains" },
            // { title: "Projects" },
            { title: "Publications" },
            // { title: "Sponsors" },
            { title: "Google Scholar Profile"},
            { title: "Videos"},
            { title: "Teaching"}
        ],
    },
    {
        title: "Administration",
    },
    {
        title: "Outreach",
        children: [
            { title: "K-12 STEM"},
            { title: "Mentoring Advice"},
            { title: "Women In Robotics"},
            { title: "Book"},
        ]
    },
    {
        title: "Media",
        children: [{ title: "Media Coverage" }, { title: "Movie" }, {title: "Videos"}],
    },
    {
        title: "Contact",
    },
]

